export class ImageForRecognition {
    tag: string;
    imgAsBase64: string;
    fileName: string;
    threshold: number;
}
